import * as Settings from '@/infra/settings'
import { getIsInsideBillma } from '@/iframeContext'
const userAgent = {
  'X-User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36 Edg/134.0.0.0'
}

const createRequestInterceptor = httpClient => {
  let { client } = httpClient

  client.interceptors.request.use(
    config => {
      config.headers = {
        'Accept-Language': Settings.getLocale(),
        Authorization: `Token ${Settings.getTokenStorage()}`,
        ...userAgent,
        ...(getIsInsideBillma() ? { 'X-From-Iframe': 'true' } : {})
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}
const createRequestInterceptorBillmma = httpClient => {
  let { client } = httpClient

  client.interceptors.request.use(
    config => {
      config.headers = {
        'Accept-Language': Settings.getLocale(),
        Authorization: `Bearer ${Settings.getTokenStorage()}`,
        ...userAgent,
        ...(getIsInsideBillma() ? { 'X-From-Iframe': 'true' } : {})
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

const createPublicRequestInterceptor = httpClient => {
  let { client } = httpClient

  client.interceptors.request.use(
    config => {
      config.headers = {
        'Accept-Language': Settings.getLocale(),
        ...userAgent
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

const createResponseInterceptor = httpClient => {
  let { client } = httpClient
  client.interceptors.response.use(
    request => {
      return request
    },
    error => {
      if (error?.response?.status === 401) {
        window.location.replace('/logout')
      }
      return Promise.reject(error)
    }
  )
}

export default {
  createRequestInterceptor,
  createPublicRequestInterceptor,
  createResponseInterceptor,
  createRequestInterceptorBillmma
}
